import React, { FC, useState, useEffect } from 'react';
import { Dialog, TextField, Checkbox, Language } from '@eta/components';
import { useTranslation } from 'react-i18next';
import {
    MessageBar,
    PrimaryButton,
    MessageBarType,
    Icon,
    Spinner,
    SpinnerSize,
} from '@fluentui/react';
import { connect, ConnectedProps } from 'react-redux';
import { isNull } from 'util';
import {
    GetRepresentationOfTaxpayerDto,
    UpdateSystemDelegateRequest,
} from '../../../Services/ClientProxy/clientProxy';
import { ReduxState } from '../../../common/reducers';
import { editErpSystem } from '../../Redux/Actions';

import './EditERP.scss';
import { isEmptyText } from '../../../helpers/utils';
import { Languages } from '../../../common/config/constants';

export interface EditERPProps {
    hidden: boolean;
    onClose: () => void;
    onSave: () => void;
    erpData: GetRepresentationOfTaxpayerDto;
}

const mapStateToProps = (state: ReduxState) => ({
    lastError: state.taxpayerProfile.lastError,
    currentLanguage: state.reduxlanguage.language,
});

const mapDispatchToProps = {
    dispatchEditErpSystem: editErpSystem,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export const EditERP: FC<PropsFromRedux & EditERPProps> = (
    props: PropsFromRedux & EditERPProps
) => {
    const { t } = useTranslation(['resources']);
    const { erpData, hidden, onClose, lastError, onSave, dispatchEditErpSystem,currentLanguage: propsCurrentLanguage } = props;
    const [currentERPData, setcurrentERPData] = useState(erpData);
    const [error, setError] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);
    const [currentLanguage, setCurrentLanguage] = useState<Language>();
    
    useEffect(() => {
        if (
           
            propsCurrentLanguage !== currentLanguage
        ) {
          
            setCurrentLanguage(propsCurrentLanguage);
           
        }
    }, [
        
        propsCurrentLanguage,
        currentLanguage,
    ]);
    useEffect(() => {
        if (erpData) {
            setcurrentERPData(
                new GetRepresentationOfTaxpayerDto({
                    ...erpData,
                    callbackUrl:
                        erpData?.callbackUrl?.split('//')[1] ?? '',
                })
            );
        }
    }, [erpData, setcurrentERPData]);

    useEffect(() => {
        if(lastError) {
        setError(lastError?.serviceError?.toString());
        }
    }, [lastError]);

    const SaveOnClick = async () => {
        setLoading(true);
        let message = '';
        if (isEmptyText(currentERPData?.profileNamePrimaryLang)) {
            message = `${t('ErpNameISRequired')}`;
        }

        if(isEmptyText(message)&&currentERPData) {
        const response = await dispatchEditErpSystem(
            new UpdateSystemDelegateRequest({
                accountingSystemId: currentERPData?.taxpayerRepresentationID,
                accountingSystemName:currentLanguage?.lang.toLocaleLowerCase().startsWith(Languages.En)? currentERPData?.profileNamePrimaryLang:currentERPData?.profileNameSecondaryLang,
                callbackUrl:
                    currentERPData?.callbackUrl === ''
                        ? ''
                        : `https://${currentERPData?.callbackUrl?.replace('https://', '')}`,
                apiKey: currentERPData?.apiKey,
                isMainTaxpayerAccountingSystem:
                    currentERPData?.isMainTaxpayerAccountingSystem,
                clientSecretExpiryInYears: undefined,
                oldSecretExpirationInHours: undefined,
            })
        );
        if (isNull((await response.payload).lastError)) {
            onSave();
        } else {
            setError(
                (await response.payload).lastError?.serviceError?.toString() ||
                ''
            );
        }
    } else{
        setError(message);
    }
    setLoading(false);
    };

    useEffect(() => {
        if(!hidden) {
            setError('');
            setcurrentERPData(erpData);
        }
    }, [hidden]);

    return (
        <Dialog
            hidden={hidden}
            onDismiss={() => {
                onClose();
            }}
            maxWidth={450}
            title={(
                <>
                    <Icon iconName="System" /> {t('form.Taxpayer.EditERP')}
                </>
            )}
        >
            <div className="editERP">
                {error && (
                    <div className="errorMessage">
                        <MessageBar
                            messageBarType={MessageBarType.blocked}
                            isMultiline={false}
                            onDismiss={()=> setError('')}
                            truncated

                        >
                            {error}
                        </MessageBar>
                    </div>
                )}
                <div className="bodyLine ClientDetails">
                    <div className="content">
                        <p>{t('form.erp.ContentEdit')}</p>
                    </div>
                </div>
                <div className="bodyLine ERP-Name ClientDetails">
                    <TextField
                        value={currentLanguage?.lang.toLocaleLowerCase().startsWith(Languages.En)?currentERPData?.profileNamePrimaryLang:currentERPData?.profileNameSecondaryLang}
                        placeholder={t('ToolTip.ErpName')}
                        label={t('form.erp.Name')}
                        onChange={(_, v) =>
                            currentLanguage?.lang === Languages.En?
                            setcurrentERPData(
                                new GetRepresentationOfTaxpayerDto({
                                    ...currentERPData,
                                    profileNamePrimaryLang: v ?? '',
                                })
                            )
                            :
                            setcurrentERPData(
                                new GetRepresentationOfTaxpayerDto({
                                    ...currentERPData,
                                    profileNameSecondaryLang: v ?? '',
                                })
                            )
                        }
                        required
                    />
                </div>
                <div className="bodyLine check ClientDetails">
                    <TextField
                        value={currentERPData?.callbackUrl?.replace('https://', '')}
                        label={t('form.erp.CallbackURL')}
                        placeholder={t('ToolTip.CallbackURL')}
                        onChange={(_, v) =>
                            setcurrentERPData(
                                new GetRepresentationOfTaxpayerDto({
                                    ...currentERPData,
                                    callbackUrl: v ?? '',
                                })
                            )
                        }
                        prefix="https://"
                    />
                </div>
                <div className="bodyLine key ClientDetails">
                    <TextField
                        value={currentERPData?.apiKey}
                        label={t('form.erp.APIKey')}
                        placeholder={t('ToolTip.APIKey')}
                        onChange={(_, v) =>
                            setcurrentERPData(
                                new GetRepresentationOfTaxpayerDto({
                                    ...currentERPData,
                                    apiKey: v ?? '',
                                })
                            )
                        }
                    />
                </div>

                <div className="bodyLine checkbox">
                    <Checkbox
                        onChange={(_, v) =>
                            setcurrentERPData(
                                new GetRepresentationOfTaxpayerDto({
                                    ...currentERPData,
                                    isMainTaxpayerAccountingSystem: v ?? false,
                                })
                            )
                        }
                        checked={currentERPData?.isMainTaxpayerAccountingSystem}
                    />
                    <span>{t('form.erp.PrimaryERPSystem')}</span>
                </div>

                <div className="bodyLine btn-addErp doneBtn">
                    <PrimaryButton type="Save" onClick={() => SaveOnClick()} disabled={loading}>
                        {t('form.erp.Save')}
                    </PrimaryButton>
                </div>
                {loading && (
                    <div className="spinnerOnButtonCLick">
                        <Spinner
                            size={SpinnerSize.large}
                            label={t('form.TaxPayer.loading')}
                            ariaLive="assertive"
                            labelPosition="bottom"
                        />
                    </div>
                )}
            </div>
        </Dialog>
    );
};
export default connector(EditERP);
